<template>
  <div>
    <div class="guide-link-wrap">
      <div v-if="config.customEntryLink1Url"><a :href="config.customEntryLink1Url" target="_blank" :style="{color:`#${config.schemeColor}`}">{{config.customEntryLink1Name}}</a></div>
      <div v-if="config.customEntryLink2Url"><a :href="config.customEntryLink2Url" target="_blank" :style="{color:`#${config.schemeColor}`}">{{config.customEntryLink2Name}}</a></div>
      <div v-if="config.customEntryLink3Url"><a :href="config.customEntryLink3Url" target="_blank" :style="{color:`#${config.schemeColor}`}">{{config.customEntryLink3Name}}</a></div>
      <div v-if="config.customEntryLink4Url"><a :href="config.customEntryLink4Url" target="_blank" :style="{color:`#${config.schemeColor}`}">{{config.customEntryLink4Name}}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'i18n',
    'config',
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>

<style scoped lang="scss">
.guide-link-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    color: #0E6CCB;
    text-decoration: none;
  }
}
</style>